export interface IAgentCommission {
  agentCommissionId: number;
  agentCommissionTiers: IAgentCommissionTier[];
  name: string;
}

/**
 * Used for Agent Commissions.
 */
export interface IAgentCommissionTier {
  commissionTierId: number;
  lowRange: number;
  highRange: null | number;
  /**
   * A decimal like `.55`.
   */
  commissionPercentage: number;
  isEdited: boolean;
  /**
   * The agentCommissionId of the IAgentCommission this tier belongs to.
   */
  commissionTable: number;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IAgentCommission = {
  getDefaultTier({
    agentCommissionId,
    lowRange = 0,
  }: {
    agentCommissionId: number;
    lowRange: number;
  }): IAgentCommissionTier {
    return {
      commissionPercentage: 0,
      commissionTable: agentCommissionId,
      commissionTierId: 0,
      highRange: 0,
      isEdited: false,
      lowRange: lowRange,
    };
  },
};
